/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoSfrIcon16Solid = forwardRef('GovKoSfrIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.567 1.176a1 1 0 0 1 .257 1.39l-1.375 2A1 1 0 0 1 6.625 5H4.75a2.25 2.25 0 0 0 0 4.5h.476l3.922-5.665A1.94 1.94 0 0 1 10.742 3h.508a4.25 4.25 0 0 1 0 8.5H9.949l-2.127 3.07a1 1 0 1 1-1.644-1.14l2.425-3.5a1 1 0 0 1 .822-.43h1.825a2.25 2.25 0 0 0 0-4.5h-.476l-3.922 5.665a1.94 1.94 0 0 1-1.594.835H4.75a4.25 4.25 0 0 1 0-8.5h1.349l1.077-1.567a1 1 0 0 1 1.39-.257Z" })));
});
